<div id="settings-template-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH CATEGORIES -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <action-list *ngIf="templateCategories"
                                 [idPrefix]="idPrefix"
                                 [items]="templateCategories"
                                 [selected]="selectedCategory"
                                 [identifier]="'name'"
                                 (select)="selectCategory($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH TEMPLATES OF SELECTED CATEGORY -->

        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>
                    <template-category *ngIf="selectedCategory"
                                       [idPrefix]="idPrefix + 'selected_category.'"
                                       [categoryTemplateList]="selectedCategory">
                    </template-category>
                </mat-card-content>
            </mat-card>

        </div>
    </div>

</div>
